import { InjectionToken } from "@angular/core";

export const FORM_STATE_PROP = new InjectionToken<string>("FORM_STATE_PROP");
export const formStatePropProvider = {
    provide: FORM_STATE_PROP,
    useValue: "commonForms",
};

export const FORM_CTAS_STATE_PROP = new InjectionToken<string>("FORM_CTAS_STATE_PROP");
export const formCtasStatePropProvider = {
    provide: FORM_CTAS_STATE_PROP,
    useValue: "commonFormCtas",
};

export const FORM_FIELD_GROUP_STATE_PROP = new InjectionToken<string>("FORM_FIELD_GROUP_STATE_PROP");
export const formFieldGroupStatePropProvider = {
    provide: FORM_FIELD_GROUP_STATE_PROP,
    useValue: "commonFormFieldGroups",
};
